export function registrationConverter(payload: Applicant) {
  let newVal = { ...payload } as any;
  newVal.isPep = newVal.isPep === "1" ? true : false;
  newVal.contactAddress = payload.address;
  newVal.currency = "NGN";
  newVal.nationality = payload.country;
  // newVal.placeOfBirth= payload.placeOfBirth
  newVal.gender = Number(newVal.gender);
  newVal.relationshipStatus = +newVal.relationshipStatus;
  newVal.networth = +newVal.networth;
  newVal.productSubscriptionFundType = +newVal.productType;
  newVal.surveySourceOfReferral = payload.survey;
  newVal.phoneNumber = payload.mobile;
  newVal.nextOfKins = [
    {
      title: "Mr",
      firstName: payload.nok_firstName,
      middleName: payload.nok_middleName,
      lastName: payload.nok_lastName,
      gender: Number(payload.nok_gender),
      relationshipWithNextOfKin: 1 || Number(payload.nok_relationship),
      phoneNumber: payload.nok_mobile,
      emailAddress: payload.nok_email,
      contactAddress: payload.nok_address,
      state: payload.nok_state,
    },
  ];
  newVal.bankCode = "090270";
  newVal.dateOfBirth = new Date(payload.dateOfBirth).toISOString();
  // newVal.passportUrl = "";
  // newVal.signatureUrl = "";
  newVal.onboardingDocuments = [
    {
      onboardingDocument: 1,
      documentName: payload.passportName,
      base64String: payload.passportUrl,
    },
    {
      onboardingDocument: 2,
      documentName: payload.signatureName,
      base64String: payload.signatureUrl,
    },
  ];

  if (payload.productType !== "1" || Number(payload.amount) > 20000) {
    newVal.onboardingDocuments.push(
      {
        onboardingDocument: 3,
        documentName: payload.utilityName,
        base64String: payload.utilityUrl,
      },
      {
        onboardingDocument: 4,
        documentName: payload.idCardName,
        base64String: payload.idCardUrl,
      }
    );
  }
  delete newVal["passportUrl"];
  delete newVal["idCardUrl"];
  delete newVal["signatureUrl"];
  delete newVal["utilityUrl"];
  return newVal;
}
